export const GET_PROFILE_EMAIL = "GET_PROFILE_EMAIL";
export const GET_PROFILE = "GET_PROFILE";
export const SET_PROFILE = "SET_PROFILE";
